module.exports = __webpack_public_path__ + "static/media/bkg13d.42d6ea24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg13d.jpg
// module id = 477
// module chunks = 0